import { payoutTicketInfoUrl } from '../../../../../common/PayoutTokenLink'
import { flowControlRefusalCardUrl } from '../../../../ticket-card/core/consts'
import { FlowControlRefusalListItem } from '../../../../ticket-card/core/refusal.types'

export const PAGE_SIZE = 50

/** Строка входа ведёт в карточку выплаты: выплата существует, своя карточка ей не нужна. */
export const refusalRowUrl = (row: Pick<FlowControlRefusalListItem, 'id' | 'stage' | 'payoutToken'>): string =>
  row.stage === 'ENTRY' && row.payoutToken ? payoutTicketInfoUrl(row.payoutToken) : flowControlRefusalCardUrl(row.id)

type Option = { value: string; label: string }

/** Подписи — те же, что бэкенд отдаёт в строках (FlowControlStage / FlowControlRefusalOutcome). */
export const STAGE_OPTIONS: Option[] = [
  { value: 'PRECHECK', label: 'Пречек' },
  { value: 'ENTRY', label: 'Вход в мэтчинг' },
]

export const OUTCOME_OPTIONS: Option[] = [
  { value: 'MERCHANT_REFUSED', label: 'Отказ мерчанту' },
  { value: 'ROUTED_ELSEWHERE', label: 'Создана через другой адаптер' },
  { value: 'OVERRIDDEN', label: 'Принята: отказ переопределён настройкой' },
  { value: 'DECLINED_AT_ENTRY', label: 'Выплата отклонена' },
  { value: 'MERCHANT_PRECHECK', label: 'Запрос мерчанта' },
  { value: 'NOT_RECORDED', label: 'Не создана, отказ каскада не записан' },
]

/**
 * Причины второго контура (FlowControlDecisionDescriber, словарь ядра — как в таймлайне мэтчинга).
 * Две причины первого контура — для записей до перехода на второй и стендов, где он выключен.
 */
export const MATCHING_REASON_OPTIONS: Option[] = [
  { value: 'v2_price_of_supply', label: 'Не хватает притока депозитов' },
  { value: 'v2_hold_cost', label: 'Удержание выплаты дороже выгоды' },
  { value: 'v2_negative_progress', label: 'Сумма ухудшает шанс закрыть выплату' },
  { value: 'v2_no_gain', label: 'Выгоды от матча нет' },
  { value: 'v2_no_candidates', label: 'В пуле не было выплат' },
  { value: 'v2_all_gated', label: 'Ни одна выплата не подошла по правилам' },
  { value: 'v2_amount_limit', label: 'Сумма выше лимита выплаты' },
  { value: 'MATCHING_PAYOUT_PERSONAL_RESTRICTED', label: 'Клиенту запрещены выплаты через мэтчинг' },
  { value: 'group_limit_exceeded', label: 'Корзина суммы заполнена (первый контур)' },
  { value: 'flow_control_rejected', label: 'Отказ по флагам контроля потока (первый контур)' },
]
